"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakeRewardRepository = void 0;
const interfaces_1 = require("@build-5/interfaces");
const Config_1 = require("../Config");
const CrudRepository_1 = require("./CrudRepository");
class StakeRewardRepository extends CrudRepository_1.CrudRepository {
    constructor(env) {
        super(env || Config_1.Build5Env.PROD, interfaces_1.PublicCollections.STAKE_REWARD);
        this.getByTokenLive = (token, startAfter) => {
            const params = {
                collection: this.col,
                fieldName: ['token'],
                fieldValue: [token],
                operator: [interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['endDate'],
                orderByDir: ['asc'],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.StakeRewardRepository = StakeRewardRepository;
